import type { IconProps } from './types';

const InfoCircleIcon = (props: IconProps) => {
  const { color = 'currentColor', size = 24, ref, ...other } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 23 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...other}
      ref={ref}
    >
      <path
        d="M0.75 11.0625C0.75 13.7976 1.8365 16.4206 3.77047 18.3546C5.70443 20.2885 8.32746 21.375 11.0625 21.375C13.7976 21.375 16.4206 20.2885 18.3546 18.3546C20.2885 16.4206 21.375 13.7976 21.375 11.0625C21.375 8.32746 20.2885 5.70443 18.3546 3.77047C16.4206 1.8365 13.7976 0.75 11.0625 0.75C8.32746 0.75 5.70443 1.8365 3.77047 3.77047C1.8365 5.70443 0.75 8.32746 0.75 11.0625Z"
        stroke={color}
        strokeWidth="1.5"
      />
      <path d="M7.3125 9.1875H11.0625V15.75" stroke={color} strokeWidth="1.5" />
      <path d="M7.3125 15.75H14.8125" stroke={color} strokeWidth="1.5" />
      <path d="M11.0625 6.375V4.5" stroke={color} strokeWidth="1.5" />
    </svg>
  );
};

export { InfoCircleIcon };
